import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/app/environments/environments.dev';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';

@Component({
  selector: 'app-modal-see-work-order',
  templateUrl: './modal-see-work-order.component.html',
  styleUrls: ['./modal-see-work-order.component.css']
})
export class ModalSeeWorkOrderComponent {
  @Output() saveEvent = new EventEmitter<any>();

  requestForm: FormGroup;
  loadingFull: boolean = true;
  loading: any;

  created_at: string = '';
  id: string = '';
  action: string = '';
  
  types: any = [
    { id: 1, name: 'Preventivo' },
    { id: 2, name: 'Correctivo' },
  ];

  productionLineSelected: string | null = null;
  productionEquipmentSelected: string | null = null;
  productionSpecialitySelected: string | null = null;

  component_stock_verification: boolean = false;
  is_necesary_stop_line: boolean = false;
  schedule_date: string = '';
  collabs: any = [];
  collaborators: any = [];
  comments_to_warehouse: string | null = null;
  id_binnacle: string | null = null;

  spare_parts_validation: any = null;
  delivery_date: string | null = null;
  validation_comments: string | null = null;

  maintenances: any = [];
  headers: any = [
    {
      label: '#',
      field: 'id',
      disableSort: false,
    },
    {
      label: 'Fecha mantenimiento',
      field: 'id',
      disableSort: false,
    },
    {
      label: 'Comentario mantenimiento',
      field: 'id',
      disableSort: false,
    },
    {
      label: 'Imagen',
      field: 'id',
      disableSort: false,
    },
  ];

  constructor(
    private fb: FormBuilder,
    public thisModalRef: MdbModalRef<ModalSeeWorkOrderComponent> | null = null,
    private crudService: GenericCrudService<any>
  ) {
    this.requestForm = this.fb.group({
      productionLineSelected: [null],
      productionEquipmentSelected: [null],
      productionSpecialitySelected: [null],
      problem: [null],
      component_stock_verification: [null],
      is_necesary_stop_line: [null],
      schedule_date: [''],
      collabs: [null],
      comments_to_warehouse: [null],
      type: [null],
      spare_parts_validation: [null],
      delivery_date: [null],
      validation_comments: [null],
      photo: new FormControl(null),
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      this.loadingFull = true;
      await Promise.all([
        this.getCollaborators(),
        this.getWorkOrdersWithRelations(),
      ]);
    } catch (error) {
      console.log('[ngOnInit] error: ', error);
    } finally {
      this.loadingFull = false;
    }
  }

  closeModal() {
    this.thisModalRef?.close(true);
  }

  onPageChange(event: any) {

  }

  async getCollaborators(): Promise<boolean> {
      const body = new FormData();
      body.append('id_company', localStorage.getItem('IdCompany') ?? '');
  
      try {
        const response: any = await firstValueFrom(
          this.crudService.crud(body, environment.GetCollaborators)
        );
        if (response && response.status === 1 && response.data) {
          this.collaborators = response.data;
          console.log("this.collaborators", this.collaborators);
        }
        return true;
      } catch (error) {
        return false;
      }
    }

  async getWorkOrdersWithRelations(): Promise<void> {
    const body = new FormData();
    body.append('id', this.id);
    try {
      const response: any = await firstValueFrom(
        this.crudService.crud(body, environment.GetWorkOrderWithRelations)
      );
      const { data } = response;
      console.log('data: ', data);
      if (response && response.status === 1 && response.data) {
        this.requestForm.patchValue({
          productionLineSelected: data.PRODUCTION_LINE_NAME,
          productionEquipmentSelected: data.PRODUCTION_EQUIPMENT_NAME,
          productionSpecialitySelected: data.PRODUCTION_SPECIALITY_NAME,
          type: data.TYPE,
          is_necesary_stop_line: data.IS_NECESARY_STOP_LINE === "1" ? true : false,
          component_stock_verification: data.COMPONENT_STOCK_VERIFICATION === "1" ? true : false,
          schedule_date: moment(data.SCHEDULE_DATE, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          comments_to_warehouse: data.COMMENTS_TO_WAREHOUSE,
          photo: data.PHOTO,
          spare_parts_validation: data.SPARE_PARTS_VALIDATION,
          delivery_date: data.DELIVERY_DATE ? moment(data.DELIVERY_DATE, 'YYYY-MM-DD').format('YYYY-MM-DD') : null,
          validation_comments: data.VALIDATION_COMMENTS,
          collabs: data.COLLABS.map((item: any) => item.ID_USER), // Patch only the IDs of the selected collaborators
        });
        this.requestForm.get('productionLineSelected')?.disable();
        this.requestForm.get('productionEquipmentSelected')?.disable();
        this.requestForm.get('productionSpecialitySelected')?.disable();
        this.requestForm.get('type')?.disable();
        this.requestForm.get('is_necesary_stop_line')?.disable();
        this.requestForm.get('component_stock_verification')?.disable();
        this.requestForm.get('schedule_date')?.disable();
        this.requestForm.get('collabs')?.disable();
        this.requestForm.get('comments_to_warehouse')?.disable();
        this.requestForm.get('spare_parts_validation')?.disable();
        this.requestForm.get('delivery_date')?.disable();
        this.requestForm.get('validation_comments')?.disable();

        this.maintenances = data.MAINTENANCES.map((item: any) => {
          item.CREATED_AT = item.CREATED_AT ? moment(item.CREATED_AT).format('DD-MM-YYYY') : '';
          item.BINNACLE_OT_DATE = item.BINNACLE_OT_DATE ? moment(item.BINNACLE_OT_DATE).format('DD-MM-YYYY') : '';
          return item;
        });
        console.log("maintenances", this.maintenances);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  }

  downloadPDF() {
    const element = document.querySelector('app-modal-see-work-order');
    if (element) {
      import('html2canvas').then(html2canvas => {
        html2canvas.default(element as HTMLElement, {
          scale: window.devicePixelRatio || 2, // Use device pixel ratio for better quality
          useCORS: true, // Handle cross-origin images
          logging: true, // Enable logging for debugging
          backgroundColor: null // Ensure transparent background
        }).then((canvas: any) => {
          const imgData = canvas.toDataURL('image/png');
          import('jspdf').then(jsPDF => {
            const pdf = new jsPDF.default('p', 'mm', 'a4');
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
            heightLeft -= pageHeight;

            while (heightLeft > 0) {
              position = heightLeft - imgHeight;
              pdf.addPage();
              pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
              heightLeft -= pageHeight;
            }

            // Embed fonts and styles if necessary
            pdf.save('modal-work-order.pdf');
          });
        });
      });
    }
  }
}
